import Card from 'react-bootstrap/Card'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'

import { formatInteger } from './weatherEventAnalyticsUtils'

export default function WeatherEventAnalyticsStaffing({ analytics }) {
  const staffing = analytics?.staffing
  if (!staffing) return null

  return (
    <Card body className="card--xs card-with-border mt-3">
      <h2 className="h5 mb-3">Staffing recommendations</h2>
      <Row className="g-3">
        <Col md={6}>
          <div className="weather-staffing-card">
            <p className="weather-staffing-card__label">Security</p>
            <p className="weather-staffing-card__value">
              {formatInteger(staffing.recommendedSecurity)} staff
            </p>
            <p className="text-muted small mb-0">
              {staffing.securityPer1000Fans} per 1,000 fans · forecast{' '}
              {formatInteger(staffing.forecastAttendance)}
            </p>
          </div>
        </Col>
        <Col md={6}>
          <div className="weather-staffing-card">
            <p className="weather-staffing-card__label">Parking</p>
            <p className="weather-staffing-card__value">
              {formatInteger(staffing.recommendedParking)} staff
            </p>
            <p className="text-muted small mb-0">
              {staffing.parkingStaffPer1000Fans} per 1,000 fans · forecast{' '}
              {formatInteger(staffing.forecastAttendance)}
            </p>
          </div>
        </Col>
      </Row>
    </Card>
  )
}
